import { setItem, getItem } from '@/common/storage';
import { getActivityId, shouldWaitForWechatAuth, isWechat, isIndexPage } from '@/utils/wechatAuth';

export function hasUserName(res) {
  if (!res || Number(res.status) === 401) return false;
  const name = res.name ?? (res.giftvote && res.giftvote.name);
  if (name === undefined || name === null) return false;
  const trimmed = String(name).trim();
  return trimmed !== '' && trimmed !== 'undefined' && trimmed !== 'null';
}

export function nameBoundKey(activityId) {
  return `nameBound_${activityId || getActivityId()}`;
}

export function markNameBound(activityId) {
  setItem(nameBoundKey(activityId), '1');
}

export function isNameBoundLocal(activityId) {
  return getItem(nameBoundKey(activityId)) === '1';
}

/** 是否允许进入首页：接口有姓名，或本机刚完成绑定 */
export function canEnterIndex(res, activityId) {
  return hasUserName(res) || isNameBoundLocal(activityId);
}

/** 绑定后进首页：show/topics/item 等 401 时在首页直接 OAuth 一次 */
export function shouldOAuthOnIndexAfterBind(reqUrl) {
  if (!shouldWaitForWechatAuth() || !isWechat()) return false;
  if (String(reqUrl || '').includes('/show/')) return true;
  return isIndexPage() && isNameBoundLocal();
}
